import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button } from "react-bootstrap";
import { addUpdateVendor, updateVendor } from "app/services/vendorService";
import { NotificationManager } from "react-notifications";
export default function SupplierAddUpdate({
  initialValues,
  setInitialValues,
  show,
  handleClose,
  loadVendorList,
}) {
  // Initial Values
  // const initialValues = {
  //   id: 0,
  //   supplierName: "",
  //   supplierDescription: "",
  //   supplierType: "",
  //   supplierCode: "",
  //   supplierActiveStatus: true,
  // };
  const [isLoading, setIsLoading] = useState(false);
  // Validation Schema
  const validationSchema = Yup.object({
    supplierName: Yup.string().required("Supplier Name is required"),
    supplierDescription: Yup.string().required(
      "Supplier Description is required"
    ),
    // supplierType: Yup.string().required("Supplier Type is required"),
    supplierCode: Yup.string().required("Supplier Code is required"),
    supplierActiveStatus: Yup.boolean(),
  });

  // Submit Handler
  const handleSubmit = async (values) => {
    debugger;
    setIsLoading(true);
    // if (values.id > 0) {
    //   const response = await updateVendor(values);
    //   try {
    //     if (response.status == "Success") {
    //       NotificationManager.success(response.message);
    //       setInitialValues({
    //         id: 0,
    //         supplierName: "",
    //         supplierDescription: "",
    //         supplierType: "",
    //         supplierCode: "",
    //         supplierActiveStatus: true,
    //       });
    //       handleClose();
    //     } else {
    //       NotificationManager.success("Something Went to be Wrong");
    //     }
    //   } catch (error) {}
    // } else {

    try {
      const response = await addUpdateVendor(values);
      if (response.status == "Success") {
        NotificationManager.success(response.message);
        setInitialValues({
          id: 0,
          supplierName: "",
          supplierType: "FLIGHT",
          supplierCode: "",
          supplierDescription: "",
          supplierApiType: "BUNDLE",
          supplierActiveStatus: true,
          internationalReturn: true,
          domesticReturn: true,
          domesticOneway: true,
          internationalOneway: true,
        });
        handleClose();
      } else {
        NotificationManager.success("Something Went to be Wrong");
      }
    } catch (error) {}
    // }
    loadVendorList();
    setIsLoading(false);
    // Add your submission logic here
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Supplier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row>
                  <Col>
                    {/* Vendor Name */}
                    <div className="mb-3">
                      <label htmlFor="supplierName" className="form-label">
                        Supplier Name
                      </label>
                      <Field
                        placeholder="Supplier Name"
                        type="text"
                        id="supplierName"
                        name="supplierName"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="supplierName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                  <Col>
                    {/* Vendor Code */}
                    <div className="mb-3">
                      <label htmlFor="supplierCode" className="form-label">
                        Supplier Code
                      </label>
                      <Field
                        placeholder="Supplier Code"
                        type="text"
                        id="supplierCode"
                        name="supplierCode"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="supplierCode"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {/* Vendor Type */}
                    <div className="mb-3">
                      <label htmlFor="supplierType" className="form-label">
                        Supplier Type
                      </label>
                      <Field
                        // placeholder="Supplier Type"
                        // type="text"
                        as="select"
                        id="supplierType"
                        name="supplierType"
                        className="form-select"
                      >
                        <option value="FLIGHT">FLIGHT</option>
                      </Field>
                      <ErrorMessage
                        name="supplierType"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                  <Col>
                    {/* Vendor Api Type */}
                    <div className="mb-3">
                      <label htmlFor="supplierApiType" className="form-label">
                        Supplier API Type
                      </label>
                      <Field
                        as="select"
                        id="supplierApiType"
                        name="supplierApiType"
                        className="form-select"
                      >
                        <option value="DIRECT">DIRECT</option>
                        <option value="BUNDLE">BUNDLE</option>
                      </Field>
                      <ErrorMessage
                        name="supplierApiType"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                </Row>

                {/* Vendor Description */}
                <div className="mb-3">
                  <label htmlFor="supplierDescription" className="form-label">
                    Supplier Description
                  </label>
                  <Field
                    as="textarea"
                    placeholder="Supplier Description"
                    id="supplierDescription"
                    name="supplierDescription"
                    className="form-control"
                    rows="4" // Optional: Set the number of rows for the textarea
                  />
                  <ErrorMessage
                    name="supplierDescription"
                    component="div"
                    className="text-danger"
                  />
                </div>
                {/* Status */}
                <div className="form-check mb-3">
                  <Field
                    type="checkbox"
                    id="supplierActiveStatus"
                    name="supplierActiveStatus"
                    className="form-check-input"
                    checked={values.supplierActiveStatus}
                    onChange={() =>
                      setFieldValue(
                        "supplierActiveStatus",
                        !values.supplierActiveStatus
                      )
                    }
                  />
                  <label
                    htmlFor="supplierActiveStatus"
                    className="form-check-label"
                  >
                    Active
                  </label>
                </div>

                <div style={{ justifyContent: "center", display: "flex" }}>
                  {isLoading ? (
                    <Button variant="primary" disabled={true}>
                      Please wait...
                    </Button>
                  ) : (
                    <Button variant="primary" type="submit">
                      Submit
                    </Button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}
